module.exports = __webpack_public_path__ + "img/Betel-Leaf.e507cd90.jpg";